import { Component,EventEmitter,Input,OnInit, Output } from '@angular/core';
import { Model } from "survey-core";
import { Serializer } from "survey-core";
import { CommonModule } from '@angular/common';
import { SurveyModule } from "survey-angular-ui";
import { SurveyCreatorModule } from 'survey-creator-angular';
import { QuizAttemptDTO } from '../models/quiz-Attempt-DTO';
import { DocumentService } from '../../../app/document/services/document.service';
import { ToastModule } from 'primeng/toast';
import { QuizAttemptsResponseInfo } from '../models/quiz-attempts-response-Info';
import { QuizResultsDTO } from '../models/quiz-resuts-DTO';
import { MessageService } from 'primeng/api';
import { CourseConstants } from '../../../app/course/constants/course.constants';
import { DocumentLibraryConstants } from '../../../app/document/document-library-constants';
import { themeJson } from './theme';

// Add a custom `score` property to survey questions
Serializer.addProperty("question", {
  name: "score:number"
});
Serializer.addProperty("itemvalue", {
  name: "score:number"
});

@Component({
  selector: 'app-quiz-completion', 
  standalone: true,
  imports: [CommonModule, SurveyModule, SurveyCreatorModule,ToastModule],
  templateUrl: './quiz-completion.component.html',
  styleUrls: ['./quiz-completion.component.scss']
})
export class QuizCompletionComponent implements OnInit {
  @Input() quiz?: string;
  model!: Model;
  @Input() quizDataToDisplay!:any;
  @Input() courseDetail?: any;
  @Input() proficiencyQuizType:any;
  @Input() isQuizReadOnly ?: boolean;
  @Input() quizAnswers!:any;
  @Output() quizCompletionModalDisplay = new EventEmitter();
  @Output() completeQuiz = new EventEmitter();
  @Output() disableTakeQuizButton = new EventEmitter();
  disableQuiz: boolean = false;
  quizAttemptDTO:QuizAttemptDTO={} as QuizAttemptDTO;
  quizAttemptsReponseInfo:QuizAttemptsResponseInfo={} as QuizAttemptsResponseInfo;
  calculatedQuizResults:QuizResultsDTO={} as QuizResultsDTO;
  
  constructor(private documentService: DocumentService,private messageService:MessageService){

  }
  
  ngOnInit() {
    var json=JSON.parse(this.quizDataToDisplay.quiz!==null? this.quizDataToDisplay.quiz : "{}");
      const survey = new Model(json);
      if(this.isQuizReadOnly){
        this.quizReadOnlyMode(survey);
      }
      function calculateMaxScore(questions:any) {
        var maxScore = 0;
        for(let i=0;i<questions.length;i++){
          if(questions[i].score===0 ||questions[i].score===undefined || 
            questions[i].score==='NaN' || questions[i].score === null ) {
            maxScore= questions.length;
            break;
          }
          else{
            maxScore += questions[i].score;
          }

        };
        return maxScore;
      }

      function calculateTotalScore(data:any) {
        var totalScore = 0;
        Object.keys(data).forEach((qName) => {
          const question:any = survey.getQuestionByValueName(qName);
          if (question.isAnswerCorrect()) {
            console.log(question);
            if (!!question.score) {
              totalScore += question.score;
            }
            else
            {
              totalScore+=1;
            }
          }
        });
        return totalScore;
      }

      survey.onCompleting.add((sender) => {
        const totalScore = calculateTotalScore(sender.data);
        const maxScore = calculateMaxScore(sender.getAllQuestions());        
        sender.setValue("maxScore", maxScore);
        sender.setValue("totalScore", totalScore);
        var quizQuestionjson=JSON.parse(this.quizDataToDisplay.quiz!==null? this.quizDataToDisplay.quiz : "{}");

      if(this.proficiencyQuizType === 0)//Quiz type as document
      {
        this.quizAttemptDTO.TrainingId= this.quizDataToDisplay.documentNumber;
        this.quizAttemptDTO.Version = String(this.quizDataToDisplay.documentVersion);
        this.quizAttemptDTO.MinimumPassingScore = this.quizDataToDisplay.minimumPassingScore;
        this.quizAttemptDTO.MaxAttempts= this.quizDataToDisplay.maximumAttempts;
        this.quizAttemptDTO.QuizMaxScore=maxScore;
        this.quizAttemptDTO.CurrentAttemptScore=totalScore;
        this.quizAttemptDTO.QuizType=this.proficiencyQuizType;
        this.quizAttemptDTO.QuizAnswers= JSON.stringify(sender.data, null, 3);
        this.quizAttemptDTO.QuizQuestions = JSON.stringify(quizQuestionjson);      }
      if (this.proficiencyQuizType === 1 || this.proficiencyQuizType === 2) //Quiz type as course
      {
        this.quizAttemptDTO.TrainingId= this.courseDetail.courseNumber;
        this.quizAttemptDTO.Version = null;
        this.quizAttemptDTO.MinimumPassingScore = Number(this.courseDetail.minimumPassingScore.replace('%',''));
        this.quizAttemptDTO.MaxAttempts= this.quizDataToDisplay.maximumAttempts;
        this.quizAttemptDTO.QuizMaxScore=maxScore;
        this.quizAttemptDTO.CurrentAttemptScore=totalScore;
        this.quizAttemptDTO.QuizType=this.proficiencyQuizType;
        this.quizAttemptDTO.QuizAnswers= JSON.stringify(sender.data, null, 3);
        this.quizAttemptDTO.QuizQuestions = JSON.stringify(quizQuestionjson);
      }
      this.CalculateQuizResults(this.quizAttemptDTO);
      sender.setValue("resultsMessage",this.calculatedQuizResults.resultsMessage);
      });   
      survey.onComplete.add((sender, options) => { 
      });

      if(!this.isQuizReadOnly){
        if(survey.title === undefined || survey.title === null || survey.title === "")
          survey.title = CourseConstants.QuizTaking_Title;
        if(survey.description === undefined|| survey.description === null || survey.description === "")
          survey.description = CourseConstants.QuizTaking_Description;
        else
          survey.description += " " + CourseConstants.QuizTaking_Description;
      }

      this.model = survey;
  }

  CalculateQuizResults(quizAttemptData:any){
    this.documentService.CalculateQuizResultsForQuizAttempt(quizAttemptData)
    .subscribe({
      next: (response) => {
        this.calculatedQuizResults=response;
        if(this.calculatedQuizResults.quizResultType===0)
        {
          let message=this.calculatedQuizResults.resultsMessage
          .replace('{0}',this.calculatedQuizResults.numberOfCorrectAnswers)
          .replace('{1}',this.calculatedQuizResults.totalQuizScore)
          .replace('{2}',this.calculatedQuizResults.resultScored)
          .replace('{3}',this.calculatedQuizResults.passingScore);
          this.messageService.add({
            severity: CourseConstants.Severity_Success,
            summary: CourseConstants.ProficiencyQuiz_ResultPass,
            detail: message,
            sticky:true
          });
        }
        else if(this.calculatedQuizResults.quizResultType===3)
        {
          let message=this.calculatedQuizResults.resultsMessage
          .replace('{0}',this.calculatedQuizResults.numberOfCorrectAnswers)
          .replace('{1}',this.calculatedQuizResults.totalQuizScore)
          .replace('{2}',this.calculatedQuizResults.resultScored)
          .replace('{3}',this.calculatedQuizResults.passingScore);
          this.messageService.add({
            severity: CourseConstants.Severity_Info,
            summary: message,
            sticky:true
          });
        }
        else
        {
          let message=this.calculatedQuizResults.resultsMessage
          .replace('{0}',this.calculatedQuizResults.maxQuizAttempts===null? DocumentLibraryConstants.DocumentTraining_QuizMaximumAttempts_Unlimited:this.calculatedQuizResults.maxQuizAttempts)
          .replace('{1}',this.calculatedQuizResults.numberOfCorrectAnswers)
          .replace('{2}',this.calculatedQuizResults.totalQuizScore)
          .replace('{3}',this.calculatedQuizResults.resultScored)
          .replace('{4}',this.calculatedQuizResults.passingScore);
          this.messageService.add({
            severity: CourseConstants.Severity_Err,
            summary: CourseConstants.ProficiencyQuiz_ResultFail,
            detail: message,
            sticky:true
          });
        }
        
        this.completeQuiz.emit();

        if(this.calculatedQuizResults.trainingCompleted || this.calculatedQuizResults.trainingLocked) {
          this.disableTakeQuizButton.emit(true);
        }
        this.quizCompletionModalDisplay.emit(false);
        
      },
      error: (error) =>  {
        this.messageService.add({
          severity: CourseConstants.Severity_Error,
          summary: CourseConstants.ProficiencyQuiz_UpdateFailed, 
          sticky: true
        });
        this.quizCompletionModalDisplay.emit(false);
      }
    });
      
      
  }

  quizReadOnlyMode(survey : Model){
      survey.applyTheme(themeJson);
      survey.data = JSON.parse(this.quizAnswers);
      survey.mode = "display";
      survey.onComplete.add((sender, options) => {
        console.log(JSON.stringify(sender.data, null, 3));
    });
    this.model = survey;
  }
}
